import {Typography} from "@mui/material"
import Grid from "@mui/material/Grid"
import {styled} from "@mui/material/styles"

import {Prop, PropLabel, Props, PropValue} from "@indebted/components/Props"
import {Page} from "@indebted/components/Page"
import {PaymentProcessingImage} from "@indebted/assets"
import {TextToHTML} from "@indebted/components/TextToHTML"

function PaymentBeingProcessing({ClientName, Amount, I18n}) {
	return (
		<Page>
			<Grid>
				<Typography align="center" variant="h6">
					{I18n.PaymentSubmitted.Title}
				</Typography>
			</Grid>

			<Grid>
				<TextToHTML align="center" text={I18n.PaymentSubmitted.Subtitle} />
			</Grid>

			<GridImage>
				<PaymentProcessingImage />
			</GridImage>

			<Props>
				<Prop>
					<PropLabel align="right">{I18n.PaymentSubmitted.PaymentAmountLabel}</PropLabel>
					<PropValue align="left">{Amount}</PropValue>
				</Prop>
				<Prop>
					<PropLabel align="right">{I18n.PaymentSubmitted.PaidToLabel}</PropLabel>
					<PropValue align="left" className="amp-mask">
						{ClientName}
					</PropValue>
				</Prop>
			</Props>
		</Page>
	)
}

const GridImage = styled(Grid)`
	margin: ${(props) => props.theme.spacing(5)};
`

export {PaymentBeingProcessing}
